import useSWR from "swr";
import { fetcher } from "src/utils/fetcher";

export default function useDebtReportProcess(id) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/reports/${id}`,
          method: "GET",
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}
